// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { runEngine } from "../../../framework/src/RunEngine";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";
import { apiCall, handleLogout, makeApiMessage } from "../../../components/src/common";
import {
  navigateTo
} from "../../../blocks/utilities/src/CustomBlockHelpers";
import { BusinessAccountDetail, BusinessAccountGroupConfigure } from "./utils";
import { concat, debounce, uniqBy } from "lodash";
export const configJSON = require("./config");

interface ICustomerInitialValues {
    name: string;
    mobile_number_prefix: string;
    mobile_number: string;
    email: string;
    company: string;
    business_customer_name: string;
    department_name: string;
    department_id: string;
    employee_id: string;
    cost_center: string;
    subcost_center: string;
    gender: string;
    street_address: string;
    city: string;
    postal_code: string;
    notes: string;
    private_notes: string;
    price_list: string;
    no_of_orders: number;
    no_of_pieces_per_order: number;
    customer_group: string |null
}

export interface BusinesCustomerDetails {
    id: string;
    type: string;
    attributes: {
      id: number;
      activated: boolean;
      name: string;
      full_phone_number: string;
      email: string | null;
      department_name: string | null;
      department_id: string | null;
      cost_center: string | null;
      sub_cost_center: string | null;
      address: string | null;
      postal_code: string | null;
      notes: string | null;
      private_notes: string | null;
      no_of_order: number | null;
      no_of_pieces: number | null;
      business_account_id: number;
      employee_id: string;
      contract_no_of_order: number | null;
      contract_no_of_pieces: number | null;
      company: {
        id: number;
        name: string;
      };
      price_list: {
        id: number;
        name: string;
      };
      city:  {
        "id": number,
        "name_en": string
        },
      gender: {
        id: number;
        label: string;
      };
      "business_account": {
        "id": number,
        "business_customer": string
      },
      "business_customer_group": {
        "id": number,
        "group_name": string
      },
    };
}

interface B2BPriceListInfo {
  id: number;
  name: string;
  created_at: string;
  updated_at: string;
  product_currency_id: string;
  tax_type: string;
  activated: boolean;
  price_list_type: string;
  price_list_to_copy: number | null;
  add_by: number | null;
  company_id: number;
}

interface B2BAccountResponse {
  no_of_pieces: number | null;
  no_of_order: number | null;
  b2b_price_list: B2BPriceListInfo;
}

export interface IB2BCompanyDropDown {
    "id": string,
    "type": string,
    "attributes": {
        "id": number,
        "name": string,
        "number_of_vats": string
    },
}

export interface IBusinessCustomerDropDown {
    "id": string,
    "type": string,
    "attributes": {
        "id": number,
        "business_customer": string,
        "contract_person": string
    }
}

export interface IB2BCustomerGroupDropdown {
  id: string;
  type: string;
  attributes: {
    id: number;
    group_name: string;
    vip: boolean;
  };
}

export interface IB2BPriceListDropDown {
  "id": string,
  "type": string,
  "attributes": {
      "id": number,
      "name": string,
      "price_list_type": string,
      "is_master_price_list": boolean
  }
}

interface IGenderDropDownItem {
  id: string;
  type: string;
  attributes: {
    id: number;
    label: string;
    module_name: string;
    created_at: string;
    updated_at: string; 
    model_name: string; 
  };
}

interface ICityDropDown {
  id: number;
  name_en: string;
  name_ar: string;
  name: string;
}

type DropdownApiResponseData = IB2BCompanyDropDown[] | IB2BPriceListDropDown[] | IGenderDropDownItem[] | IB2BCustomerGroupDropdown[];

export interface IGoogleDataOption {
  label: string;
  value: string;
}
// Customizable Area End

export interface Props {
  // Customizable Area Start
  navigation: {
    getParam: Function
  };
  id: string;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  customerInitialValues: ICustomerInitialValues
  buttonLoading: boolean
  dropdownOptions: {
    genderList: {
      id: string,
      option: string
    }[],
    cityList: {
      id: string,
      option: string
    }[]
  },
  isB2bActive: boolean
  b2bCompanyList: IB2BCompanyDropDown[]
  b2bBusinessCustomerList: IBusinessCustomerDropDown[]
  b2bCustomerGroupList: IB2BCustomerGroupDropdown[]
  b2bPriceList: IB2BPriceListDropDown[]
  errorSnackbarOpen: boolean;
  isLoading: boolean;
  isEditLoading: boolean;
  snakcbarSeverity: "error" | "warning" | "info" | "success";
  errorMessage: string;
  selectedCompany: { id: string, option: string } | null
  selectedGender: { id: string, option: string } | null
  selectedCity: { id: string, option: string } | null
  selectedCustGroup: { id: string, option: string } | null
  selectedBusinessCustomer: { id: string, option: string } | null
  snackbarMessage: string;
  snackbarOpen: boolean;
  snackbarServerity: 'success' | 'error';
  editId: string;
  selectedBusinessAccountData: BusinessAccountDetail | null;
  selectedPricelist: {
    id: number;
    name: string;
  } | null;
  filteredCustomerGroup: {
    id: string;
    option: string;
  }[];
  cost_center: {
    id: string;
    option: string;
  }[],
  subcost_center: {
    id: string;
    option: string;
  }[],
  noOfOrdrers: number | null;
  noOfPiecesOrders: number | null;
  isDataInitial: boolean;
  // Customizable Area End
}

interface SS {
  id: string;
}

export default class B2BCustomerCreationController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  authToken: string = "";
  getCompanyDropdownApiCallId: string = "";
  getCustomerGroupDropdownApiCallId: string = "";
  getPriceListDropdownApiCallId: string = "";
  addB2BCustomerApiCallId: string = "";
  getGenderDropdownOptionsApiCallId: string = ""
  getGenderDropdownOptionsApiCallId6:string=""
  getCityDropdownOptionsApiCallId: string = ""
  getBusinessCustDropdownOptionsApiCallId: string = ""
  getCompanyDropdownDetailsApiCallId: string = ""
  isEdit: boolean = this.props.navigation?.getParam('navigationBarTitleText')? true : false;
  getBusinessCustomerDetailAPICallId: string = "";
  getBusinessCustomerDetailInfoAPICallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.AccountTypeInfoMessage)
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      customerInitialValues: {
        name: '',
        mobile_number_prefix: '966',
        mobile_number: '',
        email: '',
        company: "",
        business_customer_name: '',
        department_name: '',
        department_id: '',
        employee_id: '',
        cost_center: '',
        subcost_center: '',
        gender: '',
        street_address: '',
        city: '',
        postal_code: '',
        notes: '',
        private_notes: '',
        price_list: '',
        no_of_orders:0,
        no_of_pieces_per_order:0,
        customer_group: ""
      },
      buttonLoading: false,
      dropdownOptions: {
        genderList:[],
        cityList: []
      },
      isB2bActive: false,
      b2bCompanyList: [],
      b2bCustomerGroupList: [],
      b2bBusinessCustomerList: [],
      errorSnackbarOpen: false,
      snakcbarSeverity: 'error',
      errorMessage: '',
      b2bPriceList: [],
      selectedCompany: null,
      selectedCity: null,
      snackbarMessage: "",
      snackbarOpen: false,
      snackbarServerity: 'success',
      selectedGender: null,
      selectedCustGroup:null,
      selectedBusinessCustomer: null,
      isLoading: false,
      isEditLoading: false,
      editId: "",
      selectedBusinessAccountData: null,
      selectedPricelist: null,
      filteredCustomerGroup: [],
      cost_center: [],
      subcost_center: [],
      noOfOrdrers: null,
      noOfPiecesOrders: null,
      isDataInitial: true,
      // Customizable Area End
    };

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);

    // Customizable Area Start
    this.receiveAccountTypeInfo(message)
    const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
    const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
    this.getDropdownApiCallResponse(apiRequestCallId, responseJson);
    this.addB2bCustoerApiCallResponse(apiRequestCallId, responseJson);
    this.getCityDropdownOptionApiCallResponse(apiRequestCallId, responseJson);
    this.getGenderDropdownOptionApiCallResponse(apiRequestCallId,responseJson)
    this.getCUstomerDetailsApiCallResponse(apiRequestCallId,responseJson)
    this.gerBusinessAccountDetailsApiResponse(apiRequestCallId,responseJson);
    this.gerBusinessAccountDetailsInfoApiResponse(apiRequestCallId,responseJson);
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    const authToken = localStorage.getItem("token");
    if (typeof (authToken) === "string") {
      this.authToken = authToken;
    }
    if(this.isEdit){
      const editId = this.props.navigation.getParam('navigationBarTitleText')
      this.setState({ editId:editId },()=> this.getCustomerDetailAPI()
    )
    }
    this.getDropDownApiCall()
    // Customizable Area End
  }
  // Customizable Area Start

  receiveAccountTypeInfo = (message: Message) => {
    if (message.id === getName(MessageEnum.AccountTypeInfoMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.AccountTypeInfoData)
      );
      if (recievedData.accountType) {
        this.setState({ isB2bActive: recievedData.isB2bActive })
      }
    }
  }

  getCustomerDetailAPI = () => {
    this.setState({isEditLoading: true})
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }
    const url = configJSON.B2BCustomerAPIEndpoint + "/" + this.state.editId

    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getCompanyDropdownDetailsApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getPhoneSplit = (phone: string) => {
    if(phone){
      const prefix =  phone.slice(0, 3);
      const phoneno = phone.slice(3);
      return {prefix,phoneno}
    }
  }

  getCUstomerDetailsApiCallResponse = (apiRequestCallId: string,responseJson:{data:BusinesCustomerDetails}) => {
    if(apiRequestCallId === this.getCompanyDropdownDetailsApiCallId){
      const customerData = responseJson.data.attributes
      this.setState({
        selectedBusinessCustomer: {
          id: customerData.business_account_id.toString(),
          option: ""
        },
        selectedPricelist: customerData.price_list,
        noOfOrdrers: customerData.no_of_order,
        noOfPiecesOrders: customerData.no_of_pieces,
        customerInitialValues: {
          name: customerData.name ,
          mobile_number_prefix: this.getPhoneSplit(customerData.full_phone_number)?.prefix || "",
          mobile_number: this.getPhoneSplit(customerData.full_phone_number)?.phoneno || "",
          email: customerData.email as string,
          company: String(customerData.company?.id) ,
          business_customer_name: String(customerData.business_account_id),
          department_name: customerData.department_name as string,
          department_id: customerData.department_id as string,
          employee_id: customerData.employee_id,
          cost_center: customerData.cost_center as string,
          subcost_center: customerData.sub_cost_center as string,
          gender: String(customerData.gender?.id),
          street_address: customerData.address as string,
          city: customerData.city ? String(customerData.city?.id) : "" ,
          postal_code: customerData.postal_code as string,
          notes: customerData.notes as string,
          private_notes: customerData.private_notes as string,
          price_list: String(customerData.price_list?.id),
          no_of_orders: Number(customerData.no_of_order),
          no_of_pieces_per_order: Number(customerData.no_of_pieces),
          customer_group: String(customerData.business_customer_group?.id)
        },
        cost_center: customerData.cost_center?.split(',').map((costCenter) => ({id: costCenter, option: costCenter}))??[],
        subcost_center: customerData.sub_cost_center?.split(',').map((subcostCenter) => ({id: subcostCenter, option: subcostCenter}))??[],
        isDataInitial: false,
        b2bBusinessCustomerList: customerData.business_account ? [
          {
            "id": customerData.business_account.id.toString(),
            "type": "business_account_dropdown",
            "attributes": {
                "id": customerData.business_account.id,
                "business_customer": customerData.business_account.business_customer,
                "contract_person": ""
            }
        }
        ] : []
      },()=>{
        customerData?.company?.id && this.getB2BBusinessCustomerDropDownApi(customerData.company.id)
        this.getB2BCustomerGroupDropDownApi(String(customerData.company?.id) )
        this.handleFetchBusinessAccountDetails(String(customerData.business_account_id))
        this.setState({isEditLoading:false})
      })
    }
  }

  getDropDownApiCall = () => {
    this.getB2BCompanyDropDownApi()
    this.getB2BPriceListDropDownApi()
    this.getGenderDropdownAPI()
    this.getCityList()
  }

  getB2BCompanyDropDownApi = () => {
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }

    const url = configJSON.B2BCompanyDropdownAPIEndPoint

    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getCompanyDropdownApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getB2BCustomerGroupDropDownApi = (id: string) => {
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }

    const url = configJSON.B2BCustomerGroupDropdownAPIEndPoint + "&company_id=" + id

    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getCustomerGroupDropdownApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getB2BBusinessCustomerDropDownApi = (companyId: string | number) => {
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }

    const url = configJSON.B2BBusinessCustomerDropdownAPIEndPoint + `&company_id=${companyId}`

    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getBusinessCustDropdownOptionsApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getB2BPriceListDropDownApi = () => {
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }

    const url = configJSON.B2BPriceListDropdownAPIEndPoint

    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getPriceListDropdownApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getGenderDropdownAPI() {
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }
    let url = `${configJSON.getDropdownOptionApiEndPoint}?module_name=Gender`;
    const getAccount = apiCall({
      header: headers,
      httpBody: {},
      url: url,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getGenderDropdownOptionsApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getCityList() {    
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }
    
    const requestMessage = apiCall({
      httpBody: {},
      header: headers,
      url: configJSON.getCityListApiEndPoint,
      httpMethod: configJSON.validationApiMethodType,
    });

    this.getCityDropdownOptionsApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getDropdownApiCallResponse = (apiRequestCallId: string, responseJson: { data: DropdownApiResponseData, status: number, message?: string, errors?: { message: string } }) => {
    if (apiRequestCallId === this.getCompanyDropdownApiCallId) {
      this.getCompanyDropdownAPiResponse(responseJson)
    } else if (apiRequestCallId === this.getPriceListDropdownApiCallId){
      if(responseJson?.status == 500) {
        this.setState({
          errorSnackbarOpen: true,
          errorMessage: "Internal server error",
          snakcbarSeverity: 'error'
        })
      } 
      else {
        if (this.checkGetResponse(responseJson) && !responseJson.message) {
            this.setState({ b2bPriceList: responseJson.data as IB2BPriceListDropDown[] });
        }
      }
    } else if(apiRequestCallId === this.getCustomerGroupDropdownApiCallId) {
      this.getCustomerGroupDropdownApiCallResponse(apiRequestCallId, responseJson)
    } else if(apiRequestCallId === this.getBusinessCustDropdownOptionsApiCallId) {
      this.getBusinessCustApiCallResponse(apiRequestCallId, responseJson)
    }

  }

  getCompanyDropdownAPiResponse = (responseJson: { data: IB2BCompanyDropDown[] | IB2BPriceListDropDown[] | IGenderDropDownItem[] | IB2BCustomerGroupDropdown[], status: number, message?: string, errors?: { message: string } }) => {
    if(responseJson?.status == 500) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Internal server error",
        snakcbarSeverity: 'error'
      })
    } 
    else {
      if (this.checkGetResponse(responseJson) && !responseJson.message) {
          this.setState({ b2bCompanyList: responseJson.data as IB2BCompanyDropDown[] });
      }
    }
  }

  getBusinessCustApiCallResponse (apiRequestCallId: string, responseJson: { data:IBusinessCustomerDropDown[] | IB2BCompanyDropDown[] | IB2BPriceListDropDown[] | IGenderDropDownItem[] | IB2BCustomerGroupDropdown[], status: number, message?: string, errors?: { message: string } }) {
    if(responseJson?.status == 500) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Internal server error",
        snakcbarSeverity: 'error'
      })
    } 
    else {
      if (this.checkGetResponse(responseJson) && !responseJson.message) {
        const businessCustomerList = (responseJson.data || []) as IBusinessCustomerDropDown[]
          this.setState((prev) => ({ b2bBusinessCustomerList:  uniqBy(concat(prev.b2bBusinessCustomerList, businessCustomerList), "id")}));
      }
    }
  }


  getCustomerGroupDropdownApiCallResponse(apiRequestCallId: string, responseJson: { data: IB2BCompanyDropDown[] | IB2BPriceListDropDown[] | IGenderDropDownItem[] | IB2BCustomerGroupDropdown[], status: number, message?: string, errors?: { message: string } }) {
    if(responseJson?.status == 500) {
      this.setState({
        errorSnackbarOpen: true,
        errorMessage: "Internal server error",
        snakcbarSeverity: 'error'
      })
    } 
    else {
      if (this.checkGetResponse(responseJson) && !responseJson.message) {
          this.setState({ b2bCustomerGroupList: responseJson.data as IB2BCustomerGroupDropdown[] });
      }
    }
  }

  getCityDropdownOptionApiCallResponse(apiRequestCallId: string,responseJson:{cities: ICityDropDown[] ,status: number, message?: string, errors?: { message: string }}) {
    if(apiRequestCallId === this.getCityDropdownOptionsApiCallId){
      if (this.checkGetResponse((responseJson as {status: number, message?: string, errors?: { message: string }}))) {
        this.setState(() => ({
          dropdownOptions: {
            ...this.state.dropdownOptions,
            cityList: responseJson.cities.map((item: any) => { return { id: item.id, option: item.name } })
          }
       }));
     }
    }
  }

  getGenderDropdownOptionApiCallResponse(apiRequestCallId: string,responseJson:{data:IGenderDropDownItem[] ,status: number, message?: string, errors?: { message: string }}) {
    if(apiRequestCallId === this.getGenderDropdownOptionsApiCallId){ 
      if (this.checkGetResponse(responseJson)) {
          this.setState(() => ({
            dropdownOptions: {
              ...this.state.dropdownOptions,
              genderList: responseJson.data?.map((item: any) => { return { id: item.attributes.id, option: item.attributes.label } })
            }
          }));
      }
    }
  }

  checkError(error: boolean, touch: boolean) {
    if (error && touch) {
      return true
    } else {
      return false
    }
  }

  checkGetResponse(responseJson: { errors?: { message: string } }) {
    if (responseJson && !responseJson.errors) {
      return true
    }
    else {
      handleLogout(this.props.navigation, responseJson && responseJson.errors);
      return false
    }
  }

  handleSubmit = (values:ICustomerInitialValues) => {
    this.setState({isLoading:true})
    let headers = {
      "Content-type": "application/json", 
      token: this.authToken
    }

    let url = configJSON.B2BCustomerAPIEndpoint
    let methodVal = configJSON.exampleAPiMethod
    if(this.isEdit){
      url = configJSON.B2BCustomerAPIEndpoint + "/" + this.state.editId
      methodVal = configJSON.sellerDetailsAPIMethodPUT
    }

    const body = {
      data: {
        "company_id": values.company, 
        "b2b_price_list_id": this.getSelectedPricelistForAdd(),
        city_id :values.city,
        "business_account_id": values.business_customer_name, 
        gender_id: values.gender,
        name: values.name,
        full_phone_number: values.mobile_number_prefix + values.mobile_number,
        email: values.email,
        department_name:  values.department_name,
        "department_id": values.department_id,
        "cost_center": this.businessCustomerCostCenterCondition(values), 
        "sub_cost_center": this.businessCustomerSubCostCenterCondition(values), 
        "address": values.street_address , 
        "postal_code": values.postal_code, 
        "notes": values.notes, 
        "private_notes":  values.private_notes, 
        "no_of_order": this.state.noOfOrdrers,
        "no_of_pieces": this.state.noOfPiecesOrders, 
        "activated": true, 
        "employee_id": values.employee_id,
        business_customer_group_id : this.businessCustomerGroupCondition(values)
      }
    }

    const getAccount = apiCall({
      header: headers,
      httpBody: body,
      url: url,
      httpMethod: methodVal,
    });

    this.addB2BCustomerApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  businessCustomerCostCenterCondition(values: ICustomerInitialValues)
  {
    if (!this.state.cost_center.length || !this.state.cost_center.some(obj => obj.id === values.cost_center) ) {
      return "";
    } else if (values.cost_center && values.cost_center !== "undefined") {
      return values.cost_center;
    }
    else 
    {
      return ""
    }
  }

  businessCustomerSubCostCenterCondition(values: ICustomerInitialValues)
  {
    
    if (!this.state.subcost_center.length || !this.state.subcost_center.some(obj => obj.id === values.subcost_center) ) {
      return "";
    } 
    else if (values.subcost_center && values.subcost_center !== "undefined") {
      return values.subcost_center;
    }
    else 
    {
      return ""
    }
  }

  businessCustomerGroupCondition(values: ICustomerInitialValues)
  {
    if (!this.state.filteredCustomerGroup.length || !this.state.filteredCustomerGroup.some(obj => obj.id === values.customer_group)) {
      return null;
    } else if (values.customer_group && values.customer_group !== "undefined") {
      return values.customer_group;
    }
    else 
    {
      return null
    }
  }

  addB2bCustoerApiCallResponse = (apiRequestCallId: string, responseJson: any) => {
    if (apiRequestCallId === this.addB2BCustomerApiCallId) {
      if (this.checkGetResponse(responseJson)) {
        this.setState({
          snakcbarSeverity:"success", 
          snackbarMessage: this.isEdit ? "Customer Updated Successfully." : "Customer Created Successfully.",
          snackbarOpen: true
         }, () => {
          setTimeout(() => {
            this.setState({isLoading:false})
            this.handleRedirect()
          }, 1000);
        });
      } else {
        this.setState({
          isLoading: false,
          snakcbarSeverity:"error", 
          snackbarOpen: true, 
          snackbarMessage: responseJson && responseJson.errors.full_messages[0] 
        })
      }
    }
  }

  handleComapnySelection = (value: { id: string, option: string }, setFieldValue: (field: string, fieldValue:string) => void) => {
    this.setState({
      selectedCompany: value,
      selectedBusinessCustomer: null,
      selectedBusinessAccountData: null,
      selectedPricelist: null,
      b2bBusinessCustomerList: [],
      filteredCustomerGroup: [],
      cost_center: [],
      subcost_center: [],
      isDataInitial: true,
     },() => {
      setFieldValue("company", value.id)
      setFieldValue("business_customer_name", "");
      setFieldValue("customer_group", "")
      this.setPricelistValueOnGroup();
      this.getB2BBusinessCustomerDropDownApi(value.id)
      this.getB2BCustomerGroupDropDownApi(value.id)
    })
  }

  handleCustomerGroupSelection = (
    value: { id: string; option: string },
    setFieldValue: (field: string, fieldValue: string) => void
  ) => {
    this.setState(
      {
        selectedCustGroup: value,
        selectedPricelist: null,
      },
      () => {
        setFieldValue("customer_group", value.id);
        this.handleCheckAccountPricelist(value.id);
      }
    );
    this.updateDataOnGroupSelection(value.id)
    this.handleGetBusinessGroupAccountDetails(value.id)
  };

  updateDataOnGroupSelection=(groupId:string)=>{
    this.state.selectedBusinessAccountData?.attributes.account_group_configurations.data.filter((value)=>{
      if(value.attributes.business_customer_group?.id.toString()==groupId)
      {
        this.compareAndSetValue(value,'group')
      }
    })
}

updateDataOnBusinessCustomerSelection = (groupType:string)=>{
  this.state.selectedBusinessAccountData?.attributes.account_group_configurations.data.filter((value)=>{
     this.compareAndSetValue(value,groupType)
    })
}

compareAndSetValue(value:BusinessAccountGroupConfigure, groupType:string)
{ 
   if(value.attributes.configuration_type==groupType)
  {
      this.setState({selectedPricelist:value.attributes.price_list,
        noOfOrdrers:value.attributes.remaining_no_of_order,
        noOfPiecesOrders:value.attributes.total_no_of_pieces === 0 ? null : value.attributes.total_no_of_pieces
      })
  }
}

  handleCitySelection = (value: { id: string, option: string }, setFieldValue: (field: string, fieldValue:string) => void) => {
    this.setState({
      selectedCity: value
     },() => setFieldValue("city", value.id))
  }

  handleGenderSelection = (value: { id: string, option: string }, setFieldValue: (field: string, fieldValue:string) => void) => {
    this.setState({
      selectedGender: value
     },() => setFieldValue("gender", value.id))
  }

  handleBusinessCustomerSelection = (
    value: { id: string; option: string },
    setFieldValue: (field: string, fieldValue: string) => void
  ) => {
    this.setState(
      {
        selectedBusinessCustomer: value,
        selectedPricelist: null,
      },
      () => {
        setFieldValue("business_customer_name", value.id);
        setFieldValue("customer_group", "");
        this.handleFetchBusinessAccountDetails(value.id);
        this.handleGetBusinessAccountDetails(value.id);
      }
    );
  };

  handleRedirect = () => {
    navigateTo({
      props: this.props,
      screenName: "B2BCustomerList",
    })
  }

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false })
  }
  onAddressChange = debounce((address: string, setFieldValue: (field: string, fieldValue: string) => void) => {
    if (!address) return;
    setFieldValue("street_address", address);
  }, 100)

  handleFetchBusinessAccountDetails = (accountId: string) => {
    const ApiUrl = configJSON.B2BBusinessAccountsAPIEndPoint + "/" + accountId;
    let requestMessage = makeApiMessage({
      url: ApiUrl,
      method: "GET",
    });
    this.getBusinessCustomerDetailAPICallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  gerBusinessAccountDetailsApiResponse = (
    apiRequestCallId: string,
    responseJson: { data: BusinessAccountDetail }
  ) => {
    if (apiRequestCallId === this.getBusinessCustomerDetailAPICallId) {
      this.setState({
        selectedBusinessAccountData: responseJson.data,
        cost_center: (responseJson.data.attributes.cost_center as unknown as string[]).map((costCenter) => ({id: costCenter, option: costCenter})),
        subcost_center: (responseJson.data.attributes.sub_cost_center as unknown as string[]).map((subcostCenter) => ({id: subcostCenter, option: subcostCenter})),
        filteredCustomerGroup: this.state.b2bCustomerGroupList.filter(
          (customer: IB2BCustomerGroupDropdown) => responseJson.data.attributes.no_of_groups.includes(customer.attributes.group_name))
          .map(
            (item: IB2BCustomerGroupDropdown) => ({
              id: item.id,
              option: item.attributes.group_name,
            })
          )
      });
    }
  };


  handleGetBusinessAccountDetails = (id: string) => {
    const ApiUrl = configJSON.B2BBusinessAccountsGetOrderPieceInfoAPIEndPoint+id+`&group_id=`
    let requestMessage = makeApiMessage({
      url: ApiUrl,
      method: "GET",
    });
    this.getBusinessCustomerDetailInfoAPICallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleGetBusinessGroupAccountDetails = (id: string) => {
    const ApiUrl = configJSON.B2BBusinessAccountsGetOrderPieceInfoAPIEndPoint+this.state.selectedBusinessCustomer?.id+`&group_id=${id}`
    let requestMessage = makeApiMessage({
      url: ApiUrl,
      method: "GET",
    });
    this.getBusinessCustomerDetailInfoAPICallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  gerBusinessAccountDetailsInfoApiResponse = (
    apiRequestCallId: string,
    responseJson: B2BAccountResponse
  ) => {
    if (apiRequestCallId === this.getBusinessCustomerDetailInfoAPICallId) {
      const priceList = responseJson.b2b_price_list;
      this.setState({
        noOfOrdrers: responseJson.no_of_order,
        noOfPiecesOrders: responseJson.no_of_pieces,
        selectedPricelist: priceList,
      });
    }
  };

  handleAvailableGroupData = (
    groupConfigure: { 
      data: Array<{ 
        attributes: { 
          business_customer_group?: { id: number }; 
          price_list: {
            id:number,
            name:string
          } 
        }; 
        id: string; 
        type: string; 
      }> 
    }, 
    groupId: string
  ) => {
    return groupConfigure?.data?.find(
      (item) => item?.attributes?.business_customer_group?.id === Number(groupId)
    );
  };
  handleCheckAccountPricelist = (groupId: string) => {
    const { selectedBusinessAccountData } = this.state;
    if (selectedBusinessAccountData) {
      const groupCongigure =
        selectedBusinessAccountData.attributes.account_group_configurations;
        const hasAvailableGroup = this.handleAvailableGroupData(groupCongigure,groupId)
      if (hasAvailableGroup) {
        this.setState({
          selectedPricelist: hasAvailableGroup.attributes.price_list,
        });
      } else {
        this.setState({
          selectedPricelist: selectedBusinessAccountData.attributes.price_list,
        });
      }
    }
  };

  setPricelistValueOnGroup = () => {
    const { selectedBusinessAccountData } = this.state;
    if (selectedBusinessAccountData) {
      this.setState({
        selectedPricelist: selectedBusinessAccountData.attributes.price_list,
      });
    }
  };

  handleEmptyValue=()=>{
    this.setState({
      selectedCompany: null,
      selectedCity: null,
      snackbarMessage: "",
      snackbarOpen: false,
      snackbarServerity: 'success',
      selectedGender: null,
      selectedCustGroup:null,
      selectedBusinessCustomer: null,
    })

  }

  getSelectedPricelistForAdd = () => {
    const { selectedPricelist } = this.state;
    if (selectedPricelist) {
      return selectedPricelist.id;
    } else {
      return "";
    }
  };

  handleclose=()=>{
    this.setState({
      selectedCompany: null,
      selectedGender: null,
      selectedCustGroup:null,
      selectedBusinessCustomer: null,
    })

  }

  handleCheckNullVal = (value: number | null) => {
    if(value || value == 0) {
      return value;
    } else {
      return "";
    }
  };
  // Customizable Area End
}